<template>
    <div class="container comments" v-if="user">
        <h5 class="comments-title q-mb-lg">{{$T('comments')}}</h5>

        <div v-if="loading" class="row justify-center">
            <q-spinner-hourglass color="primary" size="50px"/>
        </div>
        <template v-else>
            <div class="row q-mb-xl gutter-sm">
                <div class="col-12 q-mt-lg">
                    <q-input
                        v-model="newComment"
                        :placeholder="$T('write your comment here (optional)')"
                        type="textarea"
                        :max-height="10"
                        hide-underline
                        rows="7"
                    />
                </div>
                <div class="col">
                    <q-btn
                        outline
                        color="grey"
                        class="full-width"
                        :label="$T('cancel')"
                        @click.prevent="cancel"
                    />
                </div>
                <div class="col">
                    <q-btn
                        outline
                        color="secondary"
                        class="full-width"
                        :label="$T('send')"
                        @click.prevent="submit"
                    />
                </div>
            </div>

            <div class="comments-list">
                <div class="row comments-item" v-for="comment in comments" :key="comment.id">
                    <div class="col-auto">
                        <q-item class="q-px-none">
                            <q-item-side :key="comment.avatar" :avatar="(comment.avatar ? comment.avatar.icon : comment.avatar)" />
                        </q-item>
                    </div>
                    <div class="col">
                        <q-item>
                            <q-item-main>
                                <q-item-tile label class="q-mb-md" v-if="comment.name">{{comment.name}}</q-item-tile>
                                <div class="comment-text text-faded q-mb-md" :class="{ 'ellipsis-3-lines' : !isVisible(comment.id) }" v-html="comment.body"/>
                                <div class="row">
                                    <div class="col-auto flex flex-center">
                                        <q-icon name="calendar_today" color="faded" />
                                        <q-item-tile sublabel class="q-pl-sm" color="faded">{{ comment.created_at }}</q-item-tile>
                                    </div>
                                    <div class="col">
                                        <q-btn
                                            no-caps
                                            flat
                                            dense
                                            color="faded"
                                            class="readmore float-right"
                                            :icon-right="isVisible(comment.id) ? 'expand_less' : 'expand_more'"
                                            @click.prevent="toggleVisibility(comment.id)"
                                            :label="$T(isVisible(comment.id) ? 'read less' : 'read more')"
                                        />
                                    </div>
                                </div>
                            </q-item-main>
                        </q-item>
                    </div>
                </div>
            </div>

            <div class="row justify-between q-mt-md">
                <div class="col-auto">
                    <q-btn
                        flat
                        class=" q-pa-none"
                        icon="navigate_before"
                        :disable="page <= 1"
                        color="secondary"
                        :label="$T('previous')"
                        @click.prevent="prevPage"
                    />
                </div>

                <div class="col-auto">
                    <q-btn
                        flat
                        class=" q-pa-none"
                        icon-right="navigate_next"
                        :disable="page >= total"
                        color="secondary"
                        :label="$T('next')"
                        @click.prevent="nextPage"
                    />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import {
        QSpinnerHourglass,
        QInput,
        QBtn,
        QIcon,
        QItem,
        QItemSide,
        QItemMain,
        QItemTile,
        Cookies
    } from 'quasar-framework';

    import {mapGetters} from 'vuex'
    import axios from 'axios'

    export default {
        name: 'VComments',

        props: {
            contentType: {
                type: String,
                requered: true
            },
            contentId: {
                type: String,
                requered: true
            },

        },
        computed:{
            ...mapGetters({
                user: 'auth/user',
            }),
        },
        data: () => ({
            newComment: '',
            visibles: [],
            comments: [],
            loading: false,
            portal_base: null,
            page: 1,
            total: 1
        }),

        components: {
            QSpinnerHourglass,
            QInput,
            QBtn,
            QIcon,
            QItem,
            QItemSide,
            QItemMain,
            QItemTile
        },

        methods: {
            toggleVisibility(id) {
                this.$set(this.visibles, id, typeof this.visibles[id] !== 'undefined' ? !this.visibles[id] : true)
            },

            isVisible(id) {
                return typeof this.visibles[id] !== 'undefined' && this.visibles[id]
            },

            nextPage() {
                this.loadPage(++this.page)
            },

            prevPage() {
                this.loadPage(--this.page)
            },

            loadPage(page) {
                this.loading = true
                this.visibles = []
                axios.get(`${config.appUrl}/${this.portal_base}/${this.user.id}/comments/${this.contentType}/${this.contentId}?page=` + page)
                    .then(({data}) => {
                        this.comments = data.comments;
                        this.total = data.total;
                        this.loading = false

                    })
                    .catch(error => {
                        this.loading = false
                    })
            },

            cancel() {
                this.newComment = "";
            },

            submit() {
                this.loading = true
                axios.post(`${config.appUrl}/${this.portal_base}/${this.user.id}/comment/${this.contentType}/${this.contentId}/save`, {body: this.newComment, user: this.user})
                    .then(({data}) => {
                        this.loading = false
                        if(data.hasOwnProperty("error"))
                            this.$q.notify({
                                color: 'red',
                                icon: 'warning',
                                message: this.$T(data.error),
                                detail: this.$T(""),
                                position: 'bottom'
                            })
                        else
                        this.newComment = "";
                        this.loadPage(1);
                    })
                    .catch(error => {
                        this.loading = false
                    })
            }
        },

        mounted() {
            this.portal_base = Cookies.get('portal')
            this.loadPage(1)
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Comments.vue